import React from "react";
var __jsx = React.createElement;
import stl from "./RemoveFiltersNote.module.css";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
var RemoveFiltersNote = function RemoveFiltersNote() {
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.noteContainer
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, t("حاول تعديل بعض الفلاتر", {
    ns: "web_search"
  })), " ", /*#__PURE__*/React.createElement("span", null, t("لإيجاد نتائج بحث مطابقة", {
    ns: "web_search"
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      navigateTo("/filters");
    }
  }, t("إعادة تعيين جميع الفلاتر", {
    ns: "web_search"
  })));
};
export default RemoveFiltersNote;